import React, {Component} from 'react';
import companyValidator from '../../helpers/companyValidator';
import MembersList from '../MemberList/MembersList';
import {connect} from 'react-redux';
import {
	deleteSingleStore,
	fetchStores,
	filteringStores,
	saveNewStore,
	updateSingleStore
} from '../../actions/storesActions';
import {fetchUsers} from '../../actions/usersActions';
import {fetchCities, fetchCountries} from '../../actions/geoActions';
import {fetchCompanies, fetchOperatorTinyCompanies} from "../../actions/companyActions";
import {ACTIVE, MEMBERSMODALVIEWS, STOREMODALVIEWS} from '../../helpers/constants';
import StoresList from '../StoresList/StoresList';
import Store from '../Store/Store';
import {Alert, Button, Card, CardBody, CardTitle, Form, Input, Modal, ModalBody, ModalHeader,} from 'reactstrap';
import {I18n} from '../../I18n/components/stores';
import './stores.css';
import {fetchPackages} from "../../actions/retailActions";

class Stores extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedStore: {
				id: null,
				name: '',
				types: '',
				countryCode: '',
				cityGeonameId: '',
				status: ACTIVE,
				vendor :{
					companyId: null,
				},
				userIds:[],
				bundleIds: [],
				operatorIds: []
			},
			selectedStoreMembers: [],
			companyUsers: [],
			selectedMember: null,
			isStoreModalShown: false,
			isOkRemoveMemberModal: false,
			isOkDelStoreModal: false,
			isMembersModalShown: false,
			storeModalView: STOREMODALVIEWS.EDIT,
			membersModalView: MEMBERSMODALVIEWS.REMOVE,


			currentPage: 0,
			paginatedList: [],
			prev_filters: [],
			active_filters:[],

            filters: [],
            filter: '',
            //order: 'DESC',
            sortState: {
                id: 'name',
                desc: true
            },
            sorting: false,
		};
		this.validators = companyValidator;
	}

	componentDidMount () {
		(async () => {
			if (!this.props.companies[0]) {
				await this.props.fetchCompanies({
					page: 0
				});
			}
			try{
				await this.getGeo();
				const users = await this.props.fetchUsers();
				await this.props.getPackagesList();
				await this.props.fetchOperatorTinyCompanies();
				this.setState({
					companyUsers: this.props.users
				});
				await this.props.fetchStores({
					page: 0,
					companyId: this.props.companies[0].id
				});
			} catch(err) {
				console.error(err);
			}
		})()
	}

	componentDidUpdate(prevProps) {
		if (this.props.lang !== prevProps.lang) {
			(async() => await this.getGeo())();
		}
	}

	getGeo = async () => {
		try{
			const countries = await this.props.fetchCountries({
				lang: this.props.lang
			});
			const cities = await this.props.fetchCities({
				lang: this.props.lang,
				countryCode: this.props.companies[0].countryCode
			});
		} catch(err) {
			console.error(err);
		}
	};

	// fetchPaginatedData = async (currentPage) => {
	// 	if (!this.state.active_filters) {
	// 		this.setState({
	// 			currentPage
	// 		});
	// 		await this.props.fetchStores({
	// 			companyId: this.props.companies[0].id,
	// 			page: currentPage
	// 		});
	// 	} else {
	// 		if (isEqual(sortBy(this.state.active_filters), sortBy(this.state.prev_filters))) {
	// 			await this.props.fetchStores({
	// 				filters: this.state.active_filters.join(','),
	// 				companyId: this.props.companies[0].id,
	// 				page: currentPage
	// 			});
	// 			this.setState({
	// 				currentPage
	// 			});
	// 		} else {
	// 			await this.props.fetchStores({
	// 				filters: this.state.active_filters.join(','),
	// 				companyId: this.props.companies[0].id,
	// 			});
	// 			this.setState(state => ({
	// 				currentPage: 0,
	// 				rev_filters: state.active_filters
	// 			}));
	// 		}
	// 	}
	// };

    fetchPaginatedData = async currentPage => {
        await this.props.fetchStores({
            companyId: this.props.companies[0].id,
            filters: this.state.filters.length ? this.state.filters : false,
            sorting: this.state.sorting ? this.state.sorting : false,
            page: currentPage
        });
        await this.setState({
            currentPage,
            sortState: this.state.sorting ? this.state.sorting : {
                id: 'name',
                desc: true
            }
        });
    };

    setCurrentPage = async currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage)
        });
    };

	// setPaginatedList = paginatedList => {
	// 	this.setState({
	// 		paginatedList
	// 	})
	// };


	toggleStoreModal = () => {
		this.setState(state => ({
			isStoreModalShown: !state.isStoreModalShown
		}));
	};

	toggleMembersModal = () => {
		this.setState(state => ({
			isMembersModalShown: !state.isMembersModalShown
		}));
	};

	removeStoreMembers = async () => {
		if (this.state.selectedStore) {
			const updatedStore = this.state.selectedStore;
			const filteredUserList = updatedStore.userIds.filter(id => id !== this.state.selectedMember.id);
			updatedStore.userIds = filteredUserList;
            if (this.state.storeModalView === STOREMODALVIEWS.EDIT) {
                await this.props.updateSingleStore(updatedStore);
            }
			this.setState({
				selectedStoreMembers: this.props.users.filter(user => updatedStore.userIds.includes(user.id))
			}, () => {
				this.isOkRemoveMemberModalToggle(null);
			});
		}
	};

	addStoreMembers = async (member) => {
		console.log('add member', member);
		if (this.state.selectedStore) {
			const updatedStore = this.state.selectedStore;
			updatedStore.userIds.push(member.id);
            if (this.state.storeModalView === STOREMODALVIEWS.EDIT) {
                await this.props.updateSingleStore(updatedStore);
            }
			this.setState({
				selectedStoreMembers: this.props.users.filter(user => updatedStore.userIds.includes(user.id))
			});
		}
	};

	changeMemberListView = view => {
		this.setState({
			membersModalView: view
		}, () => {
			this.toggleMembersModal();
		});
	};

	getCompanyUsers = async () => {
		await this.props.fetchUsers();
		this.setState({
			companyUsers: this.props.users,
			selectedStoreMembers: this.props.users.filter(user => this.state.selectedStore.userIds.includes(user.id))
		}, () => {
			this.changeMemberListView(MEMBERSMODALVIEWS.ADD);
		});
	};

	getStoreMembers = async (store) => {
		if (store && store.userIds) {
			await this.props.fetchUsers();
			this.setState({
				selectedStore: store,
				companyUsers: this.props.users,
				selectedStoreMembers: this.props.users.filter(user => store.userIds.includes(user.id))
			}, () => {
				this.changeMemberListView(MEMBERSMODALVIEWS.REMOVE);
			});
		}
	};

	isOkRemoveMemberModalToggle = member => {
		this.setState(state => ({
			isOkRemoveMemberModal: !state.isOkRemoveMemberModal,
			selectedMember: member
		}));
	};

	isOkDelStoreModalToggle = store => {
		this.setState(state => ({
			isOkDelStoreModal: !state.isOkDelStoreModal,
			selectedStore: store
		}));
	};

	editStore = async (store)  => {
		 // const cities = await this.getGeoCities(store.storeData.country);
		this.getStoreMembers(store);
		this.setState({
			selectedStore: store.storeData,
			storeModalView: STOREMODALVIEWS.EDIT,
			// cities: cities
		}, () => {
			console.log('edit company', this.state.selectedStore, this.state);
			this.toggleStoreModal();
		});
	};

	updateStore = async (store) => {
		console.log('update store', store);
		await this.props.updateSingleStore(store);
		// await this.props.fetchStores({
		// 	companyId: this.props.companies[0].id
		// });
		this.fetchPaginatedData(this.state.currentPage);
		await this.clearSelectedStore();
	};

	createStore = () => {
		this.setState({
			selectedStore: {
				id: null,
				name: '',
				types: '',
				countryCode: this.props.companies[0].countryCode,
				cityGeonameId: '',
				status: ACTIVE,
				vendor :{
					companyId: this.props.companies[0].id,
				},
				userIds:[],
				bundleIds: [],
				operatorIds: []
			},
			storeModalView: STOREMODALVIEWS.NEW,
		}, () => {
			console.log('create company', this.state.selectedStore, this.state);
			this.toggleStoreModal();
		});
	};

	addNewStore = async (store) => {
		console.log('sending store', store);
		await this.props.saveNewStore(store);
		// await this.props.fetchStores({
		// 	companyId: this.props.companies[0].id
		// });
		this.fetchPaginatedData(0);
		await this.clearSelectedStore();
		this.toggleStoreModal();
	};

	deleteStore = async () => {
		console.log('delete store', this.state.selectedStore);
		await this.props.deleteSingleStore(this.state.selectedStore);
		// const stores = await this.props.fetchStores({
		// 	companyId: this.props.companies[0].id
		// });
		this.fetchPaginatedData(0);
		// this.setState({
		// 	stores: stores.data
		// }, async () => {
		// 	await this.clearSelectedStore();
		// 	this.isOkDelStoreModalToggle(null)	;
		// });
		await this.clearSelectedStore();
		this.isOkDelStoreModalToggle(null)	;
	};

	clearSelectedStore = async () => {
		return new Promise(resolve => {
			this.setState({
				selectedStore: {
					id: null,
					name: '',
					types: '',
					countryCode: '',
					cityGeonameId: '',
					status: '',
					vendor :{
						companyId: null,
					},
					userIds:[],
					bundleIds: [],
					operatorIds: []
				},
			}, resolve);
		});
	};

    onStoresFilterClick = name => {
        return event => {
            const value  = event.target.value;
            this.setState(state => {
                const filteredElemIndex = state.filters.findIndex(item => item.name === name);
                let filters = [...state.filters];
                if (filteredElemIndex !== -1) {
                    if (value && value !== '') {
                        filters[filteredElemIndex].name = name;
                        filters[filteredElemIndex].value = value;
                    } else {
                        filters = filters.filter(elem => elem.name !== name);
                    }
                } else {
                    filters = [...state.filters, {name : name, value: value}]
                }
                return {
                    [`${name}`]: value,
                    filters: filters
                }
            }, () => {
                this.fetchPaginatedData(0);
            })
        }
    };

    clearFilters = () => {
        this.setState({
            filters: [],
            filter: '',
            //order: 'ASC',
        }, () => {
            this.fetchPaginatedData(0);
        })
    };

    sortBy = async sortState => {
        const sorting = {...sortState[0]};
        await this.setState({
            sorting: sorting
        });
        await this.fetchPaginatedData(0);
    };


	render() {
		const {lang, loading, operatorTinyCompanies} = this.props;
        const storesList = loading ? <div className="loading">Loading...</div> : <StoresList
            lang={this.props.lang}
            //onStoresFilterClick={this.onStoresFilterClick}
            //filteredStores={this.props.filteredStores}
            //loading={this.props.loading}
            stores={this.props.stores}
            currentPage={this.state.currentPage}
            //createStore={this.createStore}
            editStore={this.editStore}
            deleteStore={this.isOkDelStoreModalToggle}
            getMembers={this.getStoreMembers}
            companyUsers={this.state.companyUsers}
            setCurrentPage={this.setCurrentPage}
            totalPages={this.props.pagination.totalPages}
            sortBy={this.sortBy}
            sortState={this.state.sortState}
			cities={this.props.citiesList}
			operators={operatorTinyCompanies}
			// changeMemberListView={this.changeMemberListView}
        />
		return (
			<div className='companies '>
				{/*----------------------- alerts -----------------------------------*/}
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>
				<Modal className="del-member-modal" isOpen={this.state.isOkRemoveMemberModal} toggle={() => {this.isOkRemoveMemberModalToggle(null)}}>
					<ModalHeader>{I18n[lang].sureMember}</ModalHeader>
					<ModalBody>
						<Button color="danger" className="ml-1" onClick={this.removeStoreMembers}>{I18n[lang].delete}</Button>
						<Button color="secondary" className="ml-1" onClick={() => {this.isOkRemoveMemberModalToggle(null)}}>{I18n[lang].cancel}</Button>
					</ModalBody>
				</Modal>
				<Modal className="del-modal" isOpen={this.state.isOkDelStoreModal} toggle={() => {this.isOkDelStoreModalToggle(null)}}>
					<ModalHeader>{I18n[lang].sure}</ModalHeader>
					<ModalBody>
						<Button color="danger" className="ml-1" onClick={this.deleteStore}>{I18n[lang].delete}</Button>
						<Button color="secondary" className="ml-1" onClick={() => {this.isOkDelStoreModalToggle(null)}}>{I18n[lang].cancel}</Button>
					</ModalBody>
				</Modal>
				<Modal className="stores-modal" isOpen={this.state.isStoreModalShown} toggle={this.toggleStoreModal}>
					<ModalHeader toggle={this.toggleStoreModal}>
						{this.state.storeModalView === STOREMODALVIEWS.EDIT ? `${I18n[lang].tt_changeData}` : (
							this.state.storeModalView === STOREMODALVIEWS.NEW ? `${I18n[lang].tt_addPoint}` : ''
						)}
					</ModalHeader>
					<ModalBody>
						<Store
							data={this.state.selectedStore}
							countries={this.props.countriesList}
							cities={this.props.citiesList}
							packages={this.props.packages}
							operatorTinyCompanies={this.props.operatorTinyCompanies}
							createStore={this.addNewStore}
							updateStore={this.updateStore}
							getCompanyUsers={this.getCompanyUsers}
							getMembers={this.getStoreMembers}
							closeModal={this.toggleStoreModal}
							view={this.state.storeModalView}
						/>
					</ModalBody>
				</Modal>
				<Modal className="members-modal" isOpen={this.state.isMembersModalShown} toggle={this.toggleMembersModal}>
					<ModalHeader toggle={this.toggleMembersModal}>
						{this.state.membersModalView === MEMBERSMODALVIEWS.REMOVE ? `${I18n[lang].memberRemove}` : (
							this.state.membersModalView === MEMBERSMODALVIEWS.ADD ? `${I18n[lang].memberAdd}` : ''
						)}
					</ModalHeader>
					<ModalBody>
						<MembersList
							members={this.state.selectedStoreMembers}
							view={this.state.membersModalView}
							removeMembers={this.isOkRemoveMemberModalToggle}
							addMembers={this.addStoreMembers}
							companyUsers={this.state.companyUsers}
						/>
					</ModalBody>
				</Modal>
                <Card className='storeslist '>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-border-right mr-2"></i>{I18n[this.props.lang].pointsListTitle}
                        </div>
                    </CardTitle>
                    <CardBody>
                        <div className="storeslist-card">
                            <Form className="storeslist-searchform">
                                <Input
                                    type="text"
                                    name="storeslistSearch"
                                    id="storeslistSearch"
                                    onChange={this.onStoresFilterClick('filter')}
                                    placeholder={I18n[this.props.lang].searchPlaceholder}
                                />
                            </Form>
                            <Button
                                color="primary"
                                type="button"
                                className="storeslist-card__btn"
                                onClick={this.createStore}
                            >
                                {I18n[this.props.lang].add}
                            </Button>
                        </div>
				        {storesList}
                    </CardBody>
                </Card>
			</div>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		fetchStores: query => dispatch(fetchStores(query)),
		fetchCompanies: (query) => dispatch(fetchCompanies(query)),
        filteringStores: filter => dispatch(filteringStores(filter)),
		fetchUsers: query => dispatch(fetchUsers(query)),
		getPackagesList: (query) => dispatch(fetchPackages(query)),
		saveNewStore: store => dispatch(saveNewStore(store)),
		updateSingleStore: store => dispatch(updateSingleStore(store)),
		deleteSingleStore: store => dispatch(deleteSingleStore(store)),
		fetchCountries: query => dispatch(fetchCountries(query)),
		fetchCities: query => dispatch(fetchCities(query)),
		fetchOperatorTinyCompanies: () => dispatch(fetchOperatorTinyCompanies())
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	companies: state.companiesReducer.companies,
	pagination: state.storesReducer.pagination,
	loading: state.storesReducer.loading,
	stores: state.storesReducer.stores,
	packages: state.packagesList.packages,
	filteredStores: state.filteredStoresList.stores,
	users: state.users.users,
	lang: state.languageReducer.lang,
	countriesList: state.countriesList.countries,
	citiesList: state.citiesList.cities,
	operatorTinyCompanies: state.operatorTinyCompaniesReducer.operatorTinyCompanies
});

export default connect(mapStateToProps, mapDispatchToProps)(Stores)



// WEBPACK FOOTER //
// ./src/components/Stores/Stores.js